import { DateFormatter } from './DateFormatter'
import { ImagePacker } from './ImagePacker'
import ChunkUploader from './UploadViaChunks'

export class Services {
  static dateFormatter: DateFormatter = new DateFormatter()
  static imagePacker: ImagePacker = new ImagePacker()
  static chunkUploader: ChunkUploader = new ChunkUploader()
}